import Marquee from "react-fast-marquee";

const ITEMS = [
  "#AskTasha",
  "Thursdays @ 7PM EST",
  "Free To Attend",
  "Launch · Grow · Succeed",
  "Home Health Care Agency Class Series",
  "Turn Your Passion Into Purpose",
];

export const EditorialMarquee = () => (
  <section
    data-testid="marquee-section"
    className="border-y border-cream/10 bg-ink-elevated py-6"
  >
    <Marquee speed={26} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="px-8 font-serif text-3xl italic text-cream/85 md:text-4xl">
            {item}
          </span>
          <span className="text-2xl text-gold">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
